<template>
  <App title="Warehouses">
    <Block>
      <template #header>
				<h3 class="block-title">Warehouse</h3>
			</template>
      <Datatable :options="options" ref="datatable"/>
    </Block>
  </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue';
import Datatable from '@/vue/components/Datatable.vue';
import App from '@/vue/templates/App.vue';

import { CellRender, Column } from '@/vue/utils/Datatable';
import { Component, Vue, toNative, Ref } from 'vue-facing-decorator';
import { AxiosError } from 'axios'
import $ from 'jquery';

@Component({
  components: {
    App,
    Datatable,
    Block,
  },
})
class WarehouseShow extends Vue {
  @Ref('datatable') readonly datatable!: InstanceType<typeof Datatable>;
  
/*mounted() {
    document.addEventListener('click', this.handleDeleteClick);
  }

  beforeUnmount() {
    document.removeEventListener('click', this.handleDeleteClick);
  }
*/
  get buttons() {
    return [
      'refresh',
      {
        extend: 'create',
        attr: {
          href: this.route('warehouse.page.create'),
        },
      },
      'trashed',
    ];
  }

  get columns() {
		let columns: any[] = []

		columns.push({
			data: 'id',
			orderable: true,
			name: 'id',
			title: 'Id',
		})
		columns.push({
			data: 'title',
			title: 'Title',
			orderable: true,
			name: 'title',
		})
    columns.push({
			data: 'code',
			title: 'Warehouse Code',
			orderable: true,
			name: 'code',
		})
		columns.push({
			data: 'state',
			title: 'State',
			orderable: true,
			name: 'state',
		})
		columns.push({
			data: 'country',
			title: 'Country',
			orderable: true,
		  name: 'country',
		})

		columns.push({
			data: 'created_at',
			title: 'Registered',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		columns.push(Column.actions(this.$gate))

		return columns
	}

  get options() {
    return {
      ajax: {
        url: route('warehouse.ajax.table'),
        method: 'POST',
      },
      buttons: this.buttons,
      columns: this.columns,
    };
  }

  /*handleDeleteClick = (e: any) => {
    if (e.target && e.target.classList.contains('delete-btn')) {
      const slug = e.target.getAttribute('data-id').trim();
      this.deleteWarehouse(slug);
    }
  }

  async deleteWarehouse(slug: string): Promise<void> {
    if (!confirm('Are you sure you want to delete this warehouse?')) {
      return;
    }

    try {
      const response = await this.$http.delete(
        route('warehouse.delete', { warehouse: slug }),
        {
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
            'Accept': 'application/json',
          }
        }
      );

      if (response.data.success) {
        $.notify(
          { message: response.data.message },
          { type: 'success', delay: 2000, placement: { from: 'top', align: 'right' } }
        );
        
      } else {
        throw new Error(response.data.message || 'Deletion failed');
      }
    } catch (error: any) {
      console.error('Delete error:', error);
      $.notify(
        { message: error.response?.data?.message || 'Failed to delete warehouse' },
        { type: 'danger', delay: 2000, placement: { from: 'top', align: 'right' } }
      );
    }
  }
    */
}

export default toNative(WarehouseShow);
</script>